import {useQuery} from "@tanstack/react-query";
import {readTeamName} from "../../../../../api/main/SalesApi";

export const useReadTeamName = () => {
    const {data} = useQuery({
        queryKey: ["readTeamName"],
        queryFn: async () => await readTeamName(),
        select: (res) => res?.data.result ?? [],
    });

    return {data};
};
